import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export default function Loader(props) {
  const { show, text } = props;
  return (
    <div
      className={clsx(styles.loader, 'loader')}
      style={{
        display: show ? 'flex' : 'none',
      }}
    >
      {text}
    </div>
  );
}
